import {
  FETCH_PROFILE,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAIL,
  SAVE_PROFILE,
  SAVE_PROFILE_SUCCESS,
  SAVE_PROFILE_FAIL,
} from "./types";
import Swal from "sweetalert2";
import ApiInterface from "../utils/ApiInterface";
import withReactContent from "sweetalert2-react-content";

export const fetchProfile = (dispatch) => {
  dispatch({ type: FETCH_PROFILE });

  ApiInterface.instance.me().then((response) => {
      dispatch({
        type: FETCH_PROFILE_SUCCESS,
        payload: response.data,
      });
    }).catch((error) => {
      dispatch({
        type: FETCH_PROFILE_FAIL,
        payload: error?.response?.data?.messages,
      });

      let errorMessage = error?.response?.data?.message;
      if (!!errorMessage) {
        withReactContent(Swal).fire({
          title: "Error",
          html: errorMessage,
        });
      }
    });
};

export const saveProfile = (data) => (dispatch) => {
  dispatch({ type: SAVE_PROFILE });
  ApiInterface.instance
    .updateProfile(data)
    .then((response) => {
      console.log("response of User profile: ", response);
      dispatch({
        type: SAVE_PROFILE_SUCCESS,
        payload: response.data,
      });
      alert("User Profile updated successfully");
    })
    .catch((error) => {
      dispatch({
        type: SAVE_PROFILE_FAIL,
        payload: error?.response?.data?.messages,
      });
      let errorMessage = error?.response?.data;
      if (!!errorMessage) {
        withReactContent(Swal).fire({
          title: "Error",
          html: errorMessage,
        });
      }
      alert("There was an error updating User Profile");
    });
};

export const fetchTeamsWithReducer = (id) => () => {
  ApiInterface.instance
    .getTeam(id)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      let errorMessage = error?.response?.data?.message;
      if (!!errorMessage) {
        withReactContent(Swal).fire({
          title: "Error",
          html: errorMessage,
        });
      }
    });
};
